import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityTiposActividadState,
  entityTiposActividadAdapter
} from './entity-tipos-actividad.state';

const { selectEntities, selectAll } =
  entityTiposActividadAdapter.getSelectors();

export const getError = (state: EntityTiposActividadState): any => state.error;

export const getIsLoading = (state: EntityTiposActividadState): boolean =>
  state.isLoading;

export const selectTiposActividadState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.tiposActividad
);

export const selectAllTiposActividad = createSelector(
  selectTiposActividadState,
  selectAll
);
export const selectEntitiesTiposActividad = createSelector(
  selectTiposActividadState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectTiposActividadError = createSelector(
  selectTiposActividadState,
  getError
);

// MemoizedSelector<object,any>
export const selectTiposActividadIsLoading = createSelector(
  selectTiposActividadState,
  getIsLoading
);
